import { render } from "./BtnMain.vue?vue&type=template&id=8c706178&scoped=true"
import script from "./BtnMain.vue?vue&type=script&lang=js"
export * from "./BtnMain.vue?vue&type=script&lang=js"

import "./BtnMain.vue?vue&type=style&index=0&id=8c706178&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c706178"]])

export default __exports__